import type { AxiosRequestConfig } from 'axios'

import { HttpService } from '@/infra/http'

export type TParametrosProposta = {
  termosDaProposta: string
  percentualCorretagem: number | null
  valorCorretagem: number | null
  exibeFormaPagamentoComissao: boolean
}

export class GetParametrosProposta extends HttpService {
  execute = async () => {
    return this.http.get<TParametrosProposta, AxiosRequestConfig>(`/api/v2/Parametros/proposta`)
  }
}
